import { Link as GatsbyLink } from "gatsby"
import styled from "@emotion/styled"
import isPropValid from '@emotion/is-prop-valid'
import { css, keyframes } from '@emotion/react'

import { viewOnLight } from './theme/light'
import { viewOnDark } from './theme/dark'

const size = ({ size }) => {
  if (size === 800) {
    return css({
      font:         "var(--text-650)",
      padding:      "10px 23px",
      borderRadius: 14,
      height:       64,
      minWidth:     64,
      gap:          8,
    })
  }
  else if (size === 700) {
    return css({
      font:         "var(--text-650)",
      padding:      "10px 19px",
      borderRadius: 14,
      height:       56,
      minWidth:     56,
      gap:          8,
    })
  }
  else if (size === 600) {
    return css({
      font:         "var(--text-550)",
      padding:      "10px 15px",
      borderRadius: 10,
      height:       48,
      minWidth:     48,
      gap:          8,
    })
  }
  else if (size === 500) {
    return css({
      font:         "var(--text-350)",
      padding:      "10px 14px",
      borderRadius: 10,
      height:       40,
      minWidth:     40,
      gap:          8,
    })
  }
  else if (size === 400) {
    return css({
      font:         "var(--text-350)",
      padding:      "10px 8px",
      borderRadius: 8,
      height:       32,
      minWidth:     32,
      gap:          6,
    })
  }
}

const common = () => css({
  position: "relative",
  display: "inline-flex",
  alignItems: "center",
  flexShrink: 0,
  justifyContent: "center",
  textDecoration: "none",
  whiteSpace: "nowrap",
  transition: "background var(--transition), box-shadow var(--transition)",
})

export const Button = styled.button(common, viewOnLight, viewOnDark, size)

export const A = Button.withComponent("a")

export const Link = styled(GatsbyLink, {
  shouldForwardProp: prop => isPropValid(prop) && prop !== 'isPressed'
})(common, viewOnLight, viewOnDark, size)


const contentProgress = ({ isProgress }) => {
  if (isProgress) {
    return css({
      opacity: 0,
    })
  }
}

const contentSize = ({ size }) => {
  if (size === 800) {
    return css({
      gap:          8,

      "& > svg": {
        width:  18,
        height: 18
      }
    })
  }
  else if (size === 700) {
    return css({
      gap:          8,

      "& > svg": {
        width:  18,
        height: 18
      }
    })
  }
  else if (size === 600) {
    return css({
      gap:          8,

      "& > svg": {
        width:  18,
        height: 18
      }
    })
  }
  else if (size === 500) {
    return css({
      gap:          8,

      "& > svg": {
        width:  16,
        height: 16
      }
    })
  }
  else if (size === 400) {
    return css({
      gap:          6,

      "& > svg": {
        width:  16,
        height: 16
      }
    })
  }
}


export const Content = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  ${contentProgress}
  ${contentSize}
`

const progressAnimation = keyframes`
  0%, 100% {
    box-shadow: 0 12px 0 -5px;
  }

  40% {
    box-shadow: 0 12px 0 0;
  }
`

export const Loader = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  color: currentColor;
  pointer-events: none;

  &, &:before, &:after {
    border-radius:       50%;
    width:               8px;
    height:              8px;
    animation-fill-mode: both;
    animation:           ${progressAnimation} 1.4s infinite ease-in-out;
  }

  & {
    text-indent: -9999em;
    transform: translate(-50%, -50%);
    margin-top: -12px;
    animation-delay: -0.12s
  }

  &:before, &:after {
    content:  "";
    position: absolute;
    top:      0;
  }

  &:before {
    left: -16px;
    animation-delay: -0.32s
  }

  &:after {
    left: 16px;
  }
`
